<template>
    <div class="right_wrap" v-if="isShow">
        <div class="title_wrap">
            <span class="title">{{ $t('work_schedule.rightpannel.title') }}</span>
            <button class="mgl_auto btn_round btn_white btn_s" @click="action_ShowWorkerStatsPopup">{{ $t('work_schedule.rightpannel.label_staff_work_status') }}</button>
        </div>
        <div class="staff_list_wrap">
            <div class="staff_list_scroll">
                <WorkerItem v-for="department in departments" :key="department._id" :department="department" />
            </div>
        </div>
        <WorkerStatsPopup v-if="isShowWorkerStatsPopup" @hideWorkerStatsPopup="hideWorkerStatsPopup" />
    </div>
</template>

<script>
import { workerState } from '../../worker-state'
import WorkerItem from './WorkerItem.vue'
import WorkerStatsPopup from './WorkerStatsPopup/WorkerStatsPopup.vue'
import { useManagingWorkers } from '@/composables/use-managing-workers'

export default {
    setup() {
        // 구 ManagingDataController 대체 — 부서/직원 목록을 선언형으로 구독
        const { departments, employees } = useManagingWorkers()
        return { departments, employees }
    },
    components: {
        WorkerItem,
        WorkerStatsPopup
    },
    data() {
        return {
            worker: workerState,

            isShowWorkerStatsPopup: false
        }
    },
    computed: {
        isShow: function () {
            return !this.worker.isModifyMode
        }
    },
    methods: {
        action_ShowWorkerStatsPopup() {
            this.isShowWorkerStatsPopup = true
        },

        // MARK: - Emit
        hideWorkerStatsPopup() {
            this.isShowWorkerStatsPopup = false
        }
    }
}
</script>
